export const buildPlayObject = (event) => {
  if (!event?.playId) return null;

  const playObject = {
    playId: event.playId,
    eventTime: event.eventTime,
  };

  if (event.class === "sport") {
    playObject.clock = event.clock;
    playObject.periodId = event.periodId;
  }

  return playObject;
};
